import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { TranslateModule } from '@ngx-translate/core';
import { CustomisableVariablesService } from '@shared/services/customisable-variables.service';
import { ParamsPopupCanNotEdit } from '@shared/shared/interfaces/params-popup-can-not-edit.interface';
import { CanNotEditInfoComponent } from '../../can-not-edit-info/can-not-edit-info.component';
import { PopupCanNotEditComponent } from '../popup-can-not-edit.component';

@Component({
  selector: 'popup-can-not-edit-address',
  templateUrl: './popup-can-not-edit-address.component.html',
  styleUrls: ['../popup-can-not-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule, AsyncPipe, CanNotEditInfoComponent, MatLegacyButtonModule],
})
export class PopupCanNotEditAddressComponent extends PopupCanNotEditComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) data: ParamsPopupCanNotEdit,
    customisableVariablesService: CustomisableVariablesService,
    dialogRef: MatDialogRef<PopupCanNotEditAddressComponent>
  ) {
    super(data, customisableVariablesService, dialogRef);
  }
}
